/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FcbGestionDroitsGridDto,
  FcbGestionDroitsGridDtoPaginatedResults,
  FilterCriteriaInfo,
  GestionDroitsSearch,
  SelectItem,
} from '../models/index';
import {
    FcbGestionDroitsGridDtoFromJSON,
    FcbGestionDroitsGridDtoToJSON,
    FcbGestionDroitsGridDtoPaginatedResultsFromJSON,
    FcbGestionDroitsGridDtoPaginatedResultsToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    GestionDroitsSearchFromJSON,
    GestionDroitsSearchToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
} from '../models/index';

export interface GestionDroitsBaseSearchRequest {
    GestionDroitsSearch?: GestionDroitsSearch;
}

export interface GestionDroitsGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface GestionDroitsGetSelectItemsRequest {
    searchField: string;
}

export interface GestionDroitsSavePermissionRequest {
    FcbGestionDroitsGridDto?: FcbGestionDroitsGridDto;
}

/**
 * 
 */
export class GestionDroitsApi extends runtime.BaseAPI {

    /**
     */
    async gestionDroitsBaseSearchRaw(requestParameters: GestionDroitsBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbGestionDroitsGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/GestionDroits/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GestionDroitsSearchToJSON(requestParameters.GestionDroitsSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbGestionDroitsGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async gestionDroitsBaseSearch(requestParameters: GestionDroitsBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbGestionDroitsGridDtoPaginatedResults> {
        const response = await this.gestionDroitsBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async gestionDroitsGetSearchCriteriasRaw(requestParameters: GestionDroitsGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/GestionDroits/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async gestionDroitsGetSearchCriterias(requestParameters: GestionDroitsGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.gestionDroitsGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async gestionDroitsGetSelectItemsRaw(requestParameters: GestionDroitsGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling gestionDroitsGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/GestionDroits/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async gestionDroitsGetSelectItems(requestParameters: GestionDroitsGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.gestionDroitsGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async gestionDroitsSavePermissionRaw(requestParameters: GestionDroitsSavePermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbGestionDroitsGridDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/GestionDroits/SavePermission`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FcbGestionDroitsGridDtoToJSON(requestParameters.FcbGestionDroitsGridDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbGestionDroitsGridDtoFromJSON(jsonValue));
    }

    /**
     */
    async gestionDroitsSavePermission(requestParameters: GestionDroitsSavePermissionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbGestionDroitsGridDto> {
        const response = await this.gestionDroitsSavePermissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
